import React from 'react';
import { isMobile } from 'react-device-detect';

import Desktop from './Desktop';
import Mobile from './Mobile';

export default class MainTimeline extends React.Component {
  constructor(props) {
    super(props);
    if (typeof window !== `undefined`) {
      this._isMobile = isMobile && typeof window !== 'undefined' && window.innerWidth <= 1023;
    }
  }
  render() {
    return this._isMobile ? <Mobile /> : <Desktop />;
  }
}
